import {defineStore} from 'pinia'
import {useCurrentAppPlatform} from '@toolify/client/src/modules/platform/composables/useCurrentAppPlatform'
import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {App, AppState} from '@capacitor/app'

const SESSION_TIMEOUT = 8 * 60 * 60 * 1000 // 8 hours
const LAST_ACTIVE_KEY = 'app_last_active_timestamp'

export const useAppStateMonitorStore = defineStore('appSession', () => {
  const {currentAppPlatformType} = useCurrentAppPlatform()
  let listenerHandle = null

  async function initialize() {
    if (currentAppPlatformType !== AppPlatformType.Mobile) {
      return
    }
    listenerHandle = await App.addListener('appStateChange', onAppStateChange)
  }

  async function dispose() {
    if (currentAppPlatformType !== AppPlatformType.Mobile) {
      return
    }
    if (listenerHandle) {
      await listenerHandle.remove()
      listenerHandle = null
    }
  }

  function onAppStateChange(state: AppState) {
    if (state.isActive) {
      checkSessionValidity()
    } else {
      saveLastActiveTimestamp()
    }
  }

  function saveLastActiveTimestamp() {
    const now = Date.now()
    localStorage.setItem(LAST_ACTIVE_KEY, now.toString())
  }

  function checkSessionValidity() {
    const lastActiveTimestamp = localStorage.getItem(LAST_ACTIVE_KEY)
    
    if (!lastActiveTimestamp) {
      saveLastActiveTimestamp()
      return
    }

    const lastActive = parseInt(lastActiveTimestamp, 10)
    const now = Date.now()
    const timeSinceLastActive = now - lastActive

    if (timeSinceLastActive > SESSION_TIMEOUT) {
      saveLastActiveTimestamp()
      window.location.reload()
    } else {
      saveLastActiveTimestamp()
    }
  }

  return {
    initialize,
    dispose,
    checkSessionValidity,
  }
})
